/**
 * cookiesUtils.ts
 *
 * Utility functions for working with browser cookies and JWT tokens.
 * Used for authentication and session management.
 */
// src/utils/cookieUtils.ts
import Cookies from "js-cookie";
import { COOKIE_KEYS } from "../constant/appConsatnt";

/**
 * Decodes a JWT token and returns the `userid` field from its payload, or null if not found/invalid.
 * @param jwtToken The JWT token string
 * @returns The decoded userid or null
 */
/**
 * Decodes a JWT token and returns the `userid` field from its payload, or null if not found/invalid.
 * @param jwtToken The JWT token string
 * @returns The decoded userid or null
 */
export function getUserIdFromJwt(jwtToken: string): string | number | null {
  if (!jwtToken) return null;
  try {
    const payload = jwtToken.split('.')[1];
    if (payload) {
      const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
      return decoded && decoded.userid ? decoded.userid : null;
    }
  } catch (e) {
    // Invalid token or decode error
    return null;
  }
  return null;
}

/**
 * Removes all relevant cookies for the application (logout helper).
 */
export function clearAllRelevantCookies() {
  COOKIE_KEYS.forEach((key) => Cookies.remove(key, { path: "/" }));
}

/**
 * Sets all cookies from a key-value object for the application.
 * @param data - Object with cookie key-value pairs
 */
export function setAllCookies(data: Record<string, string>) {
  Object.entries(data).forEach(([key, value]) => {
    Cookies.set(key, value, { path: "/" });
  });
}